module.exports = __webpack_public_path__ + "img/insightly.5975fcca.png";